import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

const InfoPageLink = ({ id, children, nodes: pages, className }) => {
  const page = pages.find(p => p.id === id);

  if (!page) {
    return null;
  }
  return (
    <Link
      className={className}
      to={page.pathName}
      onClick={() =>
        trackInternalNavigationClick({
          scope: InternalNavigationScope.ABOUT_REVIEWS,
          nextPage: page.pathName,
        })
      }
    >
      {children}
    </Link>
  );
};

const { number, node, arrayOf, shape, string } = PropTypes;

InfoPageLink.propTypes = {
  id: number,
  children: node,
  nodes: arrayOf(
    shape({
      id: number.isRequired,
      pathName: string.isRequired,
    })
  ),
  className: string,
};

InfoPageLink.defaultProps = {
  children: undefined,
  id: null,
  nodes: [],
  className: undefined,
};

export default connect(state => state.globals.infoPages)(InfoPageLink);
